import useMediaQuery from '@material-ui/core/useMediaQuery';

export default function useCheckScreenSize() {
  const isDesktop = useMediaQuery('(min-width:800px)');
  const isWideScreen = useMediaQuery('(min-width:1500px)');

  return [isDesktop, isWideScreen];
}
